import { render, staticRenderFns } from "./AiFactorCreator.vue?vue&type=template&id=f4b9ce02&"
import script from "./AiFactorCreator.vue?vue&type=script&lang=ts&"
export * from "./AiFactorCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports